import { ReactNode } from "react";

interface Props {
  /** Section eyebrow (small caps). */
  eyebrow?: ReactNode;
  /** Editorial title. */
  title: ReactNode;
  /** Optional short description. */
  description?: ReactNode;
  /** Right-aligned meta (badge, action link). */
  right?: ReactNode;
  children: ReactNode;
  /** If true, wrap contents in a paper card. Default true. */
  paper?: boolean;
}

/**
 * A calm section wrapper — the ONLY sectioning primitive in the admin.
 * Replaces ad-hoc <Section/> + Card combinations that produced cards-inside-cards.
 */
export function QuietSection({
  eyebrow,
  title,
  description,
  right,
  children,
  paper = true,
}: Props) {
  return (
    <section className="space-y-3">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div className="min-w-0">
          {eyebrow && <div className="eyebrow">{eyebrow}</div>}
          <h2 className="section-title">{title}</h2>
          {description && (
            <p className="text-sm text-muted-foreground mt-1 max-w-2xl">{description}</p>
          )}
        </div>
        {right && <div className="shrink-0">{right}</div>}
      </div>
      <div className={paper ? "paper-card p-4 md:p-5" : ""}>{children}</div>
    </section>
  );
}
